import Box from "ds/components/Box";
import { AccessResult } from "utils/access";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import PerformTaskAgainButton from "components/Run/elements/PerformTaskAgainButton";
import PromoteRunButton from "components/Run/elements/PromoteRunButton";
import RetryRunButton from "components/Run/elements/RetryRunButton";

import { RunHistoryEntryType } from "../../types";

type FinishedEntryProps = {
  timestamp: number;
  canPerformAgain?: AccessResult;
  runTaskCommand: string | null;
  canPromote: AccessResult;
  isProposedRun: boolean;
  stackId: string;
  runId: string;
  canRetry: AccessResult;
  runRetryBlocker: string | null;
};

const FinishedEntry = ({
  timestamp,
  canPerformAgain,
  runTaskCommand,
  stackId,
  canPromote,
  runId,
  isProposedRun,
  canRetry,
  runRetryBlocker,
}: FinishedEntryProps) => {
  const canShowPromoteButton = canPromote.result || canPromote.message;
  const canShowRetryButton =
    isProposedRun && (canRetry.result || canRetry.message || runRetryBlocker);
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.Finished} timestamp={timestamp} terminal>
      <Box gap="medium">
        {(canPerformAgain?.result || canPerformAgain?.message) && (
          <PerformTaskAgainButton
            command={runTaskCommand}
            stackId={stackId}
            errorMessage={canPerformAgain.message}
          />
        )}
        {canShowPromoteButton && (
          <PromoteRunButton stackId={stackId} runId={runId} errorMessage={canPromote.message} />
        )}
        {canShowRetryButton && (
          <RetryRunButton
            errorMessage={canRetry.message}
            runId={runId}
            stackId={stackId}
            runRetryBlocker={runRetryBlocker}
          />
        )}
      </Box>
    </HistoryEntryWrapper>
  );
};

export default FinishedEntry;
